<template>
  <div :class="$style['sample-type-form']">
    <el-table
      :data="Value"
      stripe
      style="width: 100%">
      <el-table-column
        prop="date"
        label="样品名称"
        min-width="110">
        <template slot-scope="scope">
          <el-input 
            placeholder="样品名称" 
            :disabled="scope.row.disabled"
            v-model="scope.row.orderName">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="生产单位"
        min-width="100">
        <template slot-scope="scope">
          <el-input 
            placeholder="生产单位" 
            :disabled="scope.row.disabled"
            v-model="scope.row.productionUnit">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="商标"
        min-width="100">
        <template slot-scope="scope">
          <el-input 
            placeholder="商标" 
            :disabled="scope.row.disabled"
            v-model="scope.row.brand" >
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="规格/型号"
        min-width="100">
        <template slot-scope="scope">
          <wt-selector v-model="scope.row.specificationModel" allowCreate filterable :disabled="scope.row.disabled" :options="models" placeholder="规格/型号"></wt-selector>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="样品数量"
        min-width="100">
        <template slot-scope="scope">
          <el-input 
            placeholder="样品数量" 
            :disabled="scope.row.disabled"
            v-model="scope.row.orderCount" 
            >
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="颜色"
        min-width="80">
        <template slot-scope="scope">
          <wt-selector v-model="scope.row.color" allowCreate filterable :disabled="scope.row.disabled" :options="colors" placeholder="颜色"></wt-selector>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="形态"
        min-width="80">
        <template slot-scope="scope">
          <wt-selector v-model="scope.row.shape" allowCreate filterable :disabled="scope.row.disabled" :options="shapes" placeholder="形态"></wt-selector>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="包装"
        min-width="110">
        <template slot-scope="scope">
          <wt-selector v-model="scope.row.pack" allowCreate filterable :disabled="scope.row.disabled" :options="packs" placeholder="包装"></wt-selector>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="存放条件"
        min-width="110">
        <template slot-scope="scope">
          <wt-selector v-model="scope.row.storage" allowCreate filterable :disabled="scope.row.disabled" :options="storages" placeholder="存放条件"></wt-selector>
        </template>
      </el-table-column>
      <el-table-column
        width="80">
        <template slot-scope="scope">
          <i class="el-icon-circle-close" @click="deleteItem(scope.$index)"></i>
          <i v-if="scope.row.disabled" class="el-icon-edit-outline" @click="editItem(scope.$index)"></i>

          <i  v-else class="el-icon-circle-check" @click="saveItem(scope.$index)"></i>
          
          
        </template>
      </el-table-column>
    </el-table>

    <el-button type="text" :class="$style['add-btn']" @click="addItem">添加一条样品</el-button>
  </div>
</template>
<script>
import labProductSelector from 'cps/selector/lab-product-selector'
const requiredColumn = ['orderName','productionUnit','brand','specificationModel','orderCount','color','shape','pack','storage']
import {
  colors,
  storages,
  shapes,
  models,
  packs
} from 'json/trust-deed'
export default {
  name: 'sample-type-form',
  props: {
    value: {
      type: Array,
      default:()=>[]
    },
  },
  components:{
    labProductSelector
  },
  data () {
    return {
      colors,
      storages,
      shapes,
      models,
      packs,
      Value: this.value,
      // saveValue:[]
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
    // saveValue:{
    //   handler: function (val) {
    //     console.log('====',val)
    //     this.$emit('input', val)
    //   },
    //   deep:true
    // }
  },
  methods: {
    formValidate(){
     return Promise.all(this.Value.map(e=>this.formValidateItem(e)))
    },
    formValidateItem(obj){
      const hasNull = !Object.keys(obj).length || !requiredColumn.every(key=>Object.keys(obj).includes(key) && obj[key])

      if(hasNull){
        return Promise.reject(new Error('请填写完整样品信息'))
      }else{
        return Promise.resolve()
      }
    },
    addItem () {
      if(!this.Value?.length){
        this.Value.push({disabled:false})
        return
      }
      this.formValidateItem(this.Value[this.Value.length-1]).then(()=>{
        this.Value.push({disabled:false})
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    deleteItem (index) {
      if (index === 0 && this.Value.length === 1) {
        this.$message.error('不能再删除了')
        return
      }
      this.$confirm('确定要删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.Value.splice(index, 1)
      })
    },
    editItem(index){
      this.Value[index].disabled = false
    },

    saveItem(index){
      this.formValidateItem(this.Value[index]).then(()=>{
        this.Value[index].disabled = true
        // this.saveValue.push(this.Value[index])
      }).catch((err)=>{
        this.$message.warning(err.message)
      })
    }
  }
}
</script>
<style module lang="less">
@import '~less/var.less';
  .sample-type-form {
    padding: 10px 20px;
    .el-input,
    .el-input__inner {
      height: .4rem !important;
    }
    .add-btn{
      margin:10px 0 10px 20px;
    }
    :global{
      .el-select,
      .el-input__inner{
        min-width: 100% !important;
        width: 100% !important;
      }
      
      .el-icon-circle-close,
      .el-icon-circle-check{
        font-size: 20px;
        cursor: pointer;
      }
      .el-icon-circle-close{
        color: red;
        margin-right:10px;
      }
      .el-icon-circle-check{
        color:@mainColor;
      }
      .el-icon-edit-outline{
        font-size: 19px;
        color:@mainColor;
      }
    }
  }
</style>
